import * as React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import { normalizedData } from "@utils";
import Seo from "@components/seo";
import Layout from "@layout";
import Header from "@layout/header/layout-01";
import Footer from "@layout/footer/layout-01";
import ContactArea from "@containers/contact/layout-03";
import Image from "@ui/image";
import ContentBoxArea from "@containers/content-box/layout-01";
import { ImageType } from "@utils/types";
import { BannerArea, StyledBG } from "./style";
const ItServiceTemplate = ({ location, data }) => {
    const globalContent = normalizedData(data?.allGeneral.nodes || []);
    const content = normalizedData(data?.itService.content || []);
    const pageData = data.itService;
    return (
        <Layout location={location}>
            <Seo title={pageData?.title} />
            <Header
                data={{
                    ...globalContent["header"],
                    ...globalContent["menu"],
                    socials: data.site.siteMetadata.socials,
                }}
            />
            <main className="site-wrapper-reveal">
                <BannerArea>
                    <div>
                        <StyledBG>
                            <Image
                                src={pageData.banner_image[0].src}
                                alt={
                                    pageData.banner_image[0].alt ||
                                    "Banner Image"
                                }
                            />
                        </StyledBG>
                        <div className="computer">
                            <Image
                                src={pageData.banner_image[1].src}
                                alt={
                                    pageData.banner_image[1].alt ||
                                    "Banner Image"
                                }
                            />
                        </div>
                    </div>
                </BannerArea>
                <ContentBoxArea data={content["content-box-section"]} />
                {/* <ContentBoxArea
                    data={content["content-box-section"]}
                    layout={1}
                />
                <ContentBoxArea data={content["content-box-section"]} /> */}
                <ContactArea
                    data={{
                        ...content["contact-section"],
                        contact: data.site.siteMetadata.contact,
                    }}
                />
                {/* <WhatsNewArea data={content["whats-new-section"]} /> */}
            </main>
            <Footer data={{ ...data.site.siteMetadata }} />
        </Layout>
    );
};

export const query = graphql`
    query ItServiceDetailsQuery($slug: String!) {
        allGeneral {
            nodes {
                section
                ...HeaderTwo
            }
        }
        site {
            ...Site
        }
        itService(slug: { eq: $slug }) {
            title
            tagline
            banner_image {
                alt
                src {
                    childImageSharp {
                        gatsbyImageData(
                            width: 100
                            formats: WEBP
                            layout: FULL_WIDTH
                            placeholder: DOMINANT_COLOR
                        )
                    }
                }
            }
            content {
                ...ServiceContent
            }
        }
        allCaseStudy(limit: 2) {
            nodes {
                ...CaseStudyTwo
            }
        }
    }
`;

ItServiceTemplate.propTypes = {
    location: PropTypes.shape({}),
    data: PropTypes.shape({
        allGeneral: PropTypes.shape({
            nodes: PropTypes.arrayOf(PropTypes.shape({})),
        }),
        site: PropTypes.shape({
            siteMetadata: PropTypes.shape({
                socials: PropTypes.arrayOf(PropTypes.shape({})),
            }),
        }),
        itService: PropTypes.shape({
            banner_image: PropTypes.arrayOf(PropTypes.shape(ImageType)),
            title: PropTypes.string,
            tagline: PropTypes.string,
            content: PropTypes.arrayOf(PropTypes.shape({})),
        }),
        allCaseStudy: PropTypes.shape({}),
    }),
};

export default ItServiceTemplate;

// <IntroArea data={content["intro-section"]} />
// <FaqArea space={2} data={content["faq-section"]} />
